import React from 'react';
import { Redirect, Route, Switch} from "react-router-dom";

import FileView from '@/pages/FileView';
import { ErrorPage } from '@/pages/ErrorPage';
import { useAuth } from '@/auth/SessionAuth';

const Routes: React.FC = () => {
  const { deliveryName } = useAuth();

  return (
    <Switch>
      <Route exact path="/">
        <Redirect to={`/${deliveryName}`} />
      </Route>
      <Route path={[`/${deliveryName}/:deliveryDir*`, `/${deliveryName}`]} component={FileView} />
      <Route component={ErrorPage} />

    </Switch>
  )
}

export default Routes;